import React, { useEffect, useState } from 'react';
import { volassisAPI } from '../services/api';

const OrganizationInfo = ({ currentUser }) => {
  const [adminOrganizations, setAdminOrganizations] = useState([]);

  useEffect(() => {
    if (currentUser?.isAdmin) {
      volassisAPI.getAdminOrganizations(currentUser.id).then(setAdminOrganizations);
    }
  }, [currentUser]);

  return (
    <div>
      <h2>Your Organizations</h2>
      <ul>
        {adminOrganizations.map(org => (
          <li key={org.id}>{org.name}</li>
        ))}
      </ul>
    </div>
  );
};

export default OrganizationInfo;